export var tileHover = function() {
    var $noTouch = $('html.no-touchevents');

    if ($noTouch.length > 0 || $('.desktopPage').length > 0) {
    	$('.result-list').on('mouseenter', '.product-tile', function() {
            $(this).find('.btn-outline.quick-view').show();
            $(this).find('.share').show();
        });
    	$('.result-list').on('mouseleave', '.product-tile', function() {
    		$(this).find('.btn-outline.quick-view').hide();
            $(this).find('.share').hide();
        });
    } else {
    	$('.result-list').on('click', '.product-tile', function() {
    		event.stopPropagation();
        });
    }

    if ($noTouch.length > 0 || $('.desktopPage').length > 0) {
    	$('.result-list').on('mouseenter', '.share', function() {
    		$(this).find('.share-details').show();
            event.stopPropagation();
        });
    	$('.result-list').on('mouseleave', '.share', function() {
    		$(this).find('.share-details').delay(1000).hide(0);
        });
    }


};
